import { hasLock, acquireLock, releaseLock, isExpired, sleep } from "../utils/auth"
import { EVENTS, track } from "../utils/analytics"

const MAX_RETRIES = 3

export default defineNuxtPlugin(() => {
	if (!import.meta.client) return

	const channel = new BroadcastChannel("token")

	window.addEventListener("token-expiring", async () => {
		if (hasLock()) return

		acquireLock()

		try {
			const token = useCookie("auth_token").value
			if (!token) return
			const { $store } = useNuxtApp() as any

			for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
				try {
					const newToken = await $store.dispatch("refreshToken", token)
					if (newToken) {
						useCookie("auth_token").value = newToken

						channel.postMessage({
							type: "TOKEN_REFRESHED",
							token: newToken,
						})

						return
					}
				} catch {}

				if (attempt < MAX_RETRIES) {
					await sleep(2000 * attempt)
				}
			}

			// Tracked once, after all retries are spent — not per attempt. This is
			// the silent-session-loss counter, i.e. the "hub logged me out again"
			// complaint, which is invisible today.
			track(EVENTS.SESSION_REFRESH_FAILED, {
				retry_count: MAX_RETRIES,
				token_expired: isExpired(token),
			})

			if (isExpired(token)) {
				channel.postMessage({ type: "LOGOUT" })
			}
		} finally {
			releaseLock()
		}
	})
})
